import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import styles from './CloseButton.scss'

export default class CloseButton extends PureComponent {
  render() {
    const { small, white, padded, onClick } = this.props

    const classes = cx(styles.root, { [styles.small]: small, [styles.padded]: padded })

    return (
      <div className={classes} onClick={onClick}>
        <FontAwesomeIcon icon={['fal', 'times']}/>
      </div>
    )
  }
}

CloseButton.propTypes = {
  small: PropTypes.bool,
  padded: PropTypes.bool,
  white: PropTypes.bool,
  onClick: PropTypes.func
}
